var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:({
      'width': (_vm.size + "px"),
      'height': (_vm.size + "px"),
    })},[_c('span',{staticClass:"avatar-img",style:({
        'background-image': ("url(" + _vm.image + ")"),
        'background-size': "contain",
        'width': (_vm.size + "px"),
        'height': (_vm.size + "px"),
       })}),_c('span',{staticClass:"avatar-border"})])}
var staticRenderFns = []

export { render, staticRenderFns }